import { Helmet } from "react-helmet";

import { Link } from "react-router-dom";
// import gizmoImg from '../img/text-convert-1.svg';
import HeroSection from "../general/HeroSection";
import TextSlides from '../text-gizmo/TextSlides';


import { PortableText } from '@portabletext/react';
import { useImages } from '../general/ImageProvider';
import { urlFor } from '../lib/imageUrl';
import CodeSlides from "./CodeSlides";

function TextGizmo()  {
   const images = useImages();
  
      if (!Array.isArray(images) || !images.length) {
          return <div></div>;
      }
  
      // Helper function to find an image by title
      const getImageByTitle = (title) => {
          return images.find((image) => image.title === title);
      };
  
      // Fetch specific images by their titles
  
      const slideone = getImageByTitle('Convert Case');
      const slidetwo = getImageByTitle('Find Replace Text');
      const slidethree = getImageByTitle('HTML Format');
      const slidefour = getImageByTitle('CSS Format');
  
  
  return (
    <>
       <Helmet>
        <title>Text & Code Gizmo - Transform Text and Beautify Code Effortlessly using Panacea</title>
        <meta name="description" content="Easily transform text and optimize code with Text & Code Gizmo. Convert cases, replace text, translate languages, and beautify or minify CSS & JS — all in one simple, powerful tool." />
      </Helmet>

      <section className="px-3">
      <HeroSection title="Text & Code Gizmo" subtitle="Every tool you could want to edit your text.  Your online text editor is here and forever free!"/>
        <div className="container d-desktop">
          
      {/* <div className="text-center mb-4">
          <div className="section-title text-gradient">
            Text Gizmo
          </div>
          <div className="section-subTitle">
            Every tool you could want to edit your text. Your online text editor is here and forever free!
          </div>
          </div> */}
          
        {/* Text Gizmo  */}
          <div className="row pt-5 pb-4" >
          <h3 className="text-section-title"> Text Gizmo </h3>
            <div className="col-12 col-md-6 col-lg-4 col-xl-3  mb-3 ">
              {/* First Card */}
              <Link to="/text-gizmo/convert-case">
              <div className="gizmo-card">
                <div className="gizmo-img">
                  {slideone && slideone.file && slideone.file.asset && (
                    <img
                      src={urlFor(slideone.file.asset)}
                      alt={slideone.altText || 'Sanity Image'}
                      className="img-fluid"
                    />
                  )}
                </div>
                <div className="gizmo-details-well">
                  <div className="gizmo-title">
                    {slideone?.sectionTitle || 'Default Title'}
                  </div>
                  <div className="gizmo-desc">
                    {slideone?.content ? (
                      <PortableText
                        value={slideone.content}
                        components={{
                          block: {
                            normal: ({ children }) => <p>{children}</p>,
                            h1: ({ children }) => <h1>{children}</h1>,
                            h2: ({ children }) => <h2>{children}</h2>,
                          },
                          marks: {
                            link: ({ children, value }) => (
                              <a
                                href={value.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500"
                              >
                                {children}
                              </a>
                            ),
                          },
                        }}
                      />
                    ) : 'Default description'}
                  </div>
                  <Link to="/text-gizmo" className="gizmo-card-link">
                    {slideone?.btnlabel || 'Learn More'}
                  </Link>
                </div>
              </div>
              </Link>

           
            </div>
            <div className="col-12 col-md-6 col-lg-4 col-xl-3  mb-3 ">
              <Link to="/text-gizmo/replace-text" >
              <div className="gizmo-card">
                <div className="gizmo-img">
                  {slidetwo && slidetwo.file && slidetwo.file.asset && (
                    <img
                      src={urlFor(slidetwo.file.asset)}
                      alt={slidetwo.altText || 'Sanity Image'}
                      className="img-fluid"
                    />
                  )}
                </div>
                <div className="gizmo-details-well">
                  <div className="gizmo-title">
                    {slidetwo?.sectionTitle || 'Default Title'}
                  </div>
                  <div className="gizmo-desc">
                    {slidetwo?.content ? (
                      <PortableText
                        value={slidetwo.content}
                        components={{
                          block: {
                            normal: ({ children }) => <p>{children}</p>,
                            h1: ({ children }) => <h1>{children}</h1>,
                            h2: ({ children }) => <h2>{children}</h2>,
                          },
                          marks: {
                            link: ({ children, value }) => (
                              <a
                                href={value.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500"
                              >
                                {children}
                              </a>
                            ),
                          },
                        }}
                      />
                    ) : 'Default description'}
                  </div>
                  <Link to="/text-gizmo" className="gizmo-card-link">
                    {slidetwo?.btnlabel || 'Learn More'}
                  </Link>
                </div>
              </div>
              </Link>
            </div>

         
          </div>

          <div className="row pb-5">
            <h3 className="text-section-title"> Code Gizmo </h3>
          <div className="col-12 col-md-6 col-lg-4 col-xl-3  mb-3 ">
              <Link to="/code-gizmo/html-beautify" >
              <div className="gizmo-card">
                <div className="gizmo-img">
                  {slidethree && slidethree.file && slidethree.file.asset && (
                    <img
                      src={urlFor(slidethree.file.asset)}
                      alt={slidethree.altText || 'Sanity Image'}
                      className="img-fluid"
                    />
                  )}
                </div>
                <div className="gizmo-details-well">
                  <div className="gizmo-title">
                    {slidethree?.sectionTitle || 'Default Title'}
                  </div>
                  <div className="gizmo-desc">
                    {slidethree?.content ? (
                      <PortableText
                        value={slidethree.content}
                        components={{
                          block: {
                            normal: ({ children }) => <p>{children}</p>,
                            h1: ({ children }) => <h1>{children}</h1>,
                            h2: ({ children }) => <h2>{children}</h2>,
                          },
                          marks: {
                            link: ({ children, value }) => (
                              <a
                                href={value.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500"
                              >
                                {children}
                              </a>
                            ),
                          },
                        }}
                      />
                    ) : 'Default description'}
                  </div>
                  <Link to="/text-gizmo" className="gizmo-card-link">
                    {slidethree?.btnlabel || 'Learn More'}
                  </Link>
                </div>
              </div>
              </Link>
            </div>
          <div className="col-12 col-md-6 col-lg-4 col-xl-3  mb-3 ">
              <Link to="/code-gizmo/css-beautify" >
              <div className="gizmo-card">
                <div className="gizmo-img">
                  {slidefour && slidefour.file && slidefour.file.asset && (
                    <img
                      src={urlFor(slidefour.file.asset)}
                      alt={slidefour.altText || 'Sanity Image'}
                      className="img-fluid"
                    />
                  )}
                </div>
                <div className="gizmo-details-well">
                  <div className="gizmo-title">
                    {slidefour?.sectionTitle || 'Default Title'}
                  </div>
                  <div className="gizmo-desc">
                    {slidefour?.content ? (
                      <PortableText
                        value={slidefour.content}
                        components={{
                          block: {
                            normal: ({ children }) => <p>{children}</p>,
                            h1: ({ children }) => <h1>{children}</h1>,
                            h2: ({ children }) => <h2>{children}</h2>,
                          },
                          marks: {
                            link: ({ children, value }) => (
                              <a
                                href={value.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500"
                              >
                                {children}
                              </a>
                            ),
                          },
                        }}
                      />
                    ) : 'Default description'}
                  </div>
                  <Link to="/text-gizmo" className="gizmo-card-link">
                    {slidefour?.btnlabel || 'Learn More'}
                  </Link>
                </div>
              </div>
              </Link>
            </div>
          </div>

          
        
      
          </div>
        
          <div className="d-mobile">
          <h3 className="text-section-title mt-4"> Text Gizmo </h3>

          <TextSlides className="my-2" />
          
          <h3 className="text-section-title mt-4"> Code Gizmo </h3>

          <CodeSlides />
          </div>
        </section>


       
    </>
  );
};



export default TextGizmo;
